import { injectable } from "inversify";
import { YinzCamAPIRequestParameterComponent, YinzCamAPIRequestParameters } from 'yinzcam-api';
import { AbstractReactiveMicrocomponent} from 'yinzcam-rma';
import { getAppId, getInstallId } from "./utilities";

@injectable()
export class YinzCamLoyaltyParameterComponent extends AbstractReactiveMicrocomponent<YinzCamAPIRequestParameters> implements YinzCamAPIRequestParameterComponent {
  public constructor() {
    super({ name: 'YinzCamLoyaltyParameterComponent', saveToLocalStorage: false });
  }

  protected async update($control: unknown): Promise<YinzCamAPIRequestParameters> {
    return {
      services: {
        loyalty: {
          params: {
            app_id: getAppId(),
            install_id: getInstallId(),
          }
        }
      }
    };
  }
}
